import React, { useEffect, useState } from "react";
// import Image from "next/image";
// import { authToken } from "@/helpers/authToken";
import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";
import { toast } from "react-toastify";
import Text from "./Text";
import paths from "../../constants/paths";
import { getAuthUserToken } from "../../helpers/authToken";

export default function CommentFeedBack({ comment, post }) {
  // console.log("comment", comment);
  const authToken = getAuthUserToken();

  const [typeStatus, setTypeStatus] = useState(
    comment?.like_status == 1 ? "like" : "unlike"
  );
  const [likeCount, setLikeCount] = useState(comment?.likes || 0);

  const handleStats = (type, comment_id) => {
    const formData = {
      post_id: post?.id,
      type: type,
      comment_id: comment_id,
      token: authToken,
    };
    try {
      http
        .post(`save-circle-comment-stats`, doObjToFormData(formData))
        .then((response) => {
          const data = response.data || response;
          if (data.status == 1) {
            if (data.type_status == "like") {
              setTypeStatus("like");
            } else {
              setTypeStatus(post?.like_status);
            }
            setLikeCount(data.count_likes);
          } else {
            toast.error(<Text string={data.msg} parse={true} />);
            toast.error("Technical Error");
          }
        });
    } catch (errors) {
      console.log("Errors", errors);
    }
  };

  return (
    <>
      <div className="post_footer_action">
        <img
          alt="likes"
          loading="lazy"
          src={typeStatus === "like" ? paths.SITE_BASE_URL+"/images/liked.svg" : paths.SITE_BASE_URL+"/images/like.svg"}
          width="100"
          height="100"
          decoding="async"
          className="like_btn"
          style={{ color: "transparent", cursor: "pointer" }}
          onClick={() => handleStats("like", comment?.id)}
        />
        <span>{likeCount}</span>
      </div>
    </>
  );
}
